<template>
  <div>
    <table class="table table-bordered tableinfo">
      <tr>
        <td>
          <b>Nome Tabela:</b>
          {{dados.nomeTabela}}
        </td>
        <td>
          <b>Grupo:</b>
          {{dados.Tabelas_Grupo.nomeGrupo}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ["dados"],
  data() {
    return {};
  },

  components: {}
};
</script>
<style lang="scss" scoped>
.tableinfo td {
  width: 1%;
}
</style>
